export default __webpack_public_path__ + "static/media/Mansion.3399754b.jpg";